$('.ultimos-posts .card-header').click(function(){
	switch (window.mediaSize){
		case 'xs':
			$('.ultimos-posts .list-categories').collapse('toggle')
		break;

		case 'sm':
			$('.ultimos-posts .list-categories').collapse('toggle')
		break;

		default:
			return false;
		break;
	}
});

$('.categorias .card-header').click(function(){
	switch (window.mediaSize){
		case 'xs':
			$('.categorias .list-categories').collapse('toggle')
		break;

		case 'sm':
			$('.categorias .list-categories').collapse('toggle')
		break;

		default:
			return false;
		break;
	}
});

$('.buscas .card-header').click(function(){
	switch (window.mediaSize){
		case 'xs':
			$('.buscas .card-body').collapse('toggle')
		break;

		case 'sm':
			$('.buscas .card-body').collapse('toggle')
		break;

		default:
			return false;
		break;
	}
});